/**
 * Quiet landing page until the family archive lands. Folio is the
 * family-facing browse experience for the `archive` collection
 * (PROJECT.md §The apps) — image-forward, casual, with comments and
 * reactions. The browse surfaces ship after Bindery's curation tools
 * exist, since there's nothing to browse before then.
 *
 * No API call from this page on purpose — there's nothing to fetch yet,
 * and the previous health-check stub generated misleading errors once
 * the API moved behind Cloudflare Access.
 */
export function HomePage() {
  return (
    <section>
      <div
        style={{
          fontSize: 'var(--font-size-caption)',
          fontWeight: 'var(--font-weight-medium)',
          letterSpacing: 'var(--letter-spacing-wide)',
          textTransform: 'uppercase',
          color: 'var(--text-tertiary)',
          marginBottom: '1.5rem',
        }}
      >
        Family archive
      </div>
      <h2
        style={{
          fontSize: 'clamp(1.5rem, 3vw, 2rem)',
          fontWeight: 500,
          letterSpacing: '-0.02em',
          marginBottom: '0.75rem',
        }}
      >
        Gathered over generations.
      </h2>
      <p
        style={{
          color: 'var(--text-secondary)',
          maxWidth: '56ch',
          marginBottom: '2rem',
        }}
      >
        Folio is the room where the family archive opens up — photos and
        documents, side by side, across the decades. The browse
        experience arrives once there&rsquo;s something to browse; for now,
        the room is empty and the lamp is off.
      </p>
    </section>
  );
}
